import React from 'react'

// Loading: the one way a screen, panel or section says it's fetching — a
// small spinner and "Loading…", centred, the same size everywhere. `inline`
// sits it at the start of a line inside a form or sheet instead.
export function Loading({ inline = false, label = 'Loading…' }: { inline?: boolean; label?: string }) {
  return (
    <p className={inline ? 'loading loading--inline' : 'loading'} role="status">
      <span className="loading__spinner" aria-hidden="true" />
      {label}
    </p>
  )
}

// EmptyState: nothing here yet (P6) — a title, one sentence, and at most one
// action to fill it.
export function EmptyState({ title, children, action, headingLevel = 2 }: {
  title: string
  children?: React.ReactNode
  action?: React.ReactNode
  headingLevel?: 2 | 3
}) {
  const Heading = headingLevel === 2 ? 'h2' : 'h3'
  return (
    <div className="empty-state">
      <Heading className="empty-state__title">{title}</Heading>
      {children && <p className="empty-state__text">{children}</p>}
      {action}
    </div>
  )
}
